"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filter = void 0;

var _Observable = require("./Observable");

var filter = function filter(f) {
  return function (source) {
    return (0, _Observable.mkObservable)(function (observer) {
      return source.subscribe({
        next: function next(x) {
          return f(x) ? observer.next(x) : void 8;
        },
        error: function error(err) {
          return observer.error(err);
        },
        complete: function complete() {
          return observer.complete();
        }
      });
    });
  };
};

exports.filter = filter;